
import Input from '../../shared/input';
import Icon from '@/ui-kit/components/icon';
import {
  InputProperty,
  InputEventType,
  InputType,
  InputSlotType,
} from '../../shared/input/enums';
import { IconProperty, IconType } from '@/ui-kit/components/icon/enums';
import { StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import PasswordInputProps from './mixins/PasswordInputProps';
import { PasswordInputProperty } from './enums';
import { ControlEventType } from '../../enums';

export default {
  name: 'PasswordInput',
  components: {
    Input,
    Icon,
  },
  mixins: [PasswordInputProps],
  data() {
    return {
      InputProperty,
      PasswordInputProperty,
      InputEventType,
      InputType,
      InputSlotType,
      IconProperty,
      IconType,
      StyleSizeType,
      StyleColorSchemeType,
      isShowPassword: false,
    };
  },
  computed: {
    passwordFillType() {
      return this.isShowPassword ? InputType.Text : InputType.Password;
    },
    passwordIconType() {
      return this.isShowPassword ? IconType.Eye : IconType.CrossedEye;
    },
  },
  methods: {
    getIsPasswordValid(value) {
      if (!value) {
        return true;
      }

      const trimmedValue = value.trim();

      return !!trimmedValue;
    },
    handleInput(event) {
      const isTextValid = this.getIsPasswordValid(event.target.value);

      if (!isTextValid) {
        // eslint-disable-next-line
        event.target.value = this[PasswordInputProperty.Value];

        return;
      }

      this.$emit(ControlEventType.Change, event.target.value);
    },
    handleInputFocus(event) {
      this.$emit(ControlEventType.Focus, event.target.value);
    },
    handleInputBlur(event) {
      this.$emit(ControlEventType.Blur, event.target.value);
    },
    handleAppendIconClick() {
      this.isShowPassword = !this.isShowPassword;
    },
  },
};
